module.exports = __webpack_public_path__ + "static/media/beefalotreats.2330f11c.png";